module.exports = __webpack_public_path__ + "img/53_23.bf9804a8.png";